import React from 'react';
import LabelsGridColumns from './LabelsGridColumns';
import DataGrid from '../grid/grid';

class LabelsGrid extends React.Component {

    reload() {
        this.refs['dGrid'].getWrappedInstance().reload();
    }

    render() {
        const {
            labels,
            gridId,
            onFetchedItems
        } = this.props;

        return (
            <div>
                <DataGrid
                    ref={'dGrid'}
                    gridId={gridId}
                    data={labels}
                    url={'/labels'}
                    columns={LabelsGridColumns}
                    onFetchedItems={onFetchedItems}
                />
            </div>
        )
    }
}
export default LabelsGrid;



// WEBPACK FOOTER //
// ./src/containers/labels/LabelsGrid.jsx